<script>
    import { createEventDispatcher } from "svelte";
    import { portal } from "svelte-portal";
    import { fly } from "svelte/transition";
    const dispatch = createEventDispatcher();
    export let show = false;
    //'bottom' | 'top' | 'left' | 'right'| 'center'
    export let position = "bottom";
    const clsName = "sui-popup";
    let el;
    //
    function inStart() {
        setTimeout(() => {
            el.classList.add(`${position}`);
            el.classList.add("visible");
        });
    }
    function outStart() {
        el.classList.remove(`${position}`);
    }
    function handleClose() {
        show = false;
        dispatch("close", "blank_area");
    }

    const motionMap = {
        bottom: { y: 200 },
        top: { y: -200 },
        left: { x: -200 },
        right: { x: 200 },
        center: { delay: 200 },
    };

    $: motion = motionMap[position];
</script>

{#if show}
    <div
        role="dialog"
        aria-modal={show}
        class={`${clsName} ${$$props.class || ""}`}
        use:portal
        bind:this={el}
        transition:fly={motion}
        on:introstart={inStart}
        on:outrostart={outStart}
        on:click={handleClose}
        on:click
    >
        <div
            class={`${clsName}-content`}
            part={`${clsName}-content`}
            on:click|stopPropagation
        >
            <slot />
        </div>
    </div>
{/if}

<style lang="less">
    @import "./popup.less";
</style>
